module.exports = __webpack_public_path__ + "assets/img/36_1439.79b7bd76.jpg";